import { initialPlayerValues } from '../../profile/player'
import { resolveAssetUrl, type ImageLike } from '../../../utils/assetUrl'
import { initialRosterPlayerValues } from './constants'
import type { RosterPlayerFormValues } from './types'

/**
 * The subset of a player-search result we carry into the roster "add existing"
 * flow. We deliberately do NOT fetch the full profile (no /users/me/players/:id
 * call) — the search row already gives us everything we display: name, email,
 * and image. The BE keeps the player's own profile on copy, so the rest of the
 * personal fields aren't needed.
 */
export interface RosterSearchPlayer {
  id: string
  name_first?: string | null
  name_last?: string | null
  email?: string | null
  image?: ImageLike
}

const str = (v: unknown): string =>
  v === null || v === undefined ? '' : String(v)

/**
 * Build the add-existing form values from a search result. Only first/last name,
 * email and the image are seeded (these are shown read-only for confirmation);
 * every other personal field and all roster fields start blank. No network call.
 */
export const mapSearchPlayerToForm = (
  player: RosterSearchPlayer
): RosterPlayerFormValues => ({
  ...initialPlayerValues,
  ...initialRosterPlayerValues,
  firstName: str(player.name_first),
  lastName: str(player.name_last),
  email: str(player.email),
  imageUrl: resolveAssetUrl(player.image) || '',
})
